import http from '@/requests/http'

class MessageLoad {
  static findAll (params) {
    return http.post('messages/load', params)
  }
  static viewSummary (params) {
    return http.post('messages/load/summary', params)
  }
  static store (params) {
    return http.post('messages/load/store', params)
  }
  static getBalance () {
    return http.post('messages/load/balance')
  }
}

export default MessageLoad
